import { FC } from 'react';

import PhoneIcon from '@icons/18/phone.svg';
import MailIcon from '@icons/mail.svg';

import { OfficePhoneEmailProps } from '../../types';
import styles from './OfficePhoneEmail.module.scss';

const OfficePhoneEmail: FC<OfficePhoneEmailProps> = ({ phoneLabel, phoneTel, email }) => (
    <div className={styles.officePhoneEmail_root}>
        <div className={styles.officePhoneEmail_row}>
            <span className={styles.officePhoneEmail_icon} aria-hidden>
                <PhoneIcon />
            </span>
            <a href={`tel:${phoneTel}`} className={styles.officePhoneEmail_link}>
                {phoneLabel}
            </a>
        </div>
        <div className={styles.officePhoneEmail_row}>
            <span className={styles.officePhoneEmail_icon} aria-hidden>
                <MailIcon />
            </span>
            <a href={`mailto:${email}`} className={styles.officePhoneEmail_link}>
                {email}
            </a>
        </div>
    </div>
);

export default OfficePhoneEmail;
